import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { DMSv3SettingsDashboardQueryKeys } from "modules/DMSv3/Settings/queryKeys";
import { ApiInstance } from "utils/Api";

export const usePurgeLocationMutation = () =>
  useTypedMutation<number, void>({
    mutationFn: async dealer_location_id => (await ApiInstance.post(`/config/purge`, { dealer_location_id }, ENV.dmsv3BaseURL)).data,
    onSuccess: () => typedQueryClient.invalidateQueries(DMSv3SettingsDashboardQueryKeys.dealers)
  });
